"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _CompanyUserInfoModal = require("../modal/CompanyUserInfoModal");

var _CompanyUserInfoModal2 = _interopRequireDefault(_CompanyUserInfoModal);

var _PrivateUserInfoModal = require("../modal/PrivateUserInfoModal");

var _PrivateUserInfoModal2 = _interopRequireDefault(_PrivateUserInfoModal);

var _Input = require("../form/Input");

var _Input2 = _interopRequireDefault(_Input);

var _SubmitButton = require("../form/SubmitButton");

var _SubmitButton2 = _interopRequireDefault(_SubmitButton);

var _RadioGroup = require("../form/RadioGroup");

var _RadioGroup2 = _interopRequireDefault(_RadioGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OrderLicenseForm = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(OrderLicenseForm, _Component);

  function OrderLicenseForm() {
    (0, _classCallCheck3.default)(this, OrderLicenseForm);

    var _this = (0, _possibleConstructorReturn3.default)(this, (OrderLicenseForm.__proto__ || (0, _getPrototypeOf2.default)(OrderLicenseForm)).call(this));

    _this.onSubmit = function () {
      _this.props.confirmPage();
    };

    _this.toggleProUserModal = function () {
      _this.setState({
        showProUserInfoModal: !_this.state.showProUserInfoModal
      });
    };

    _this.toggleFreeUserModal = function () {
      _this.setState({
        showFreeUserInfoModal: !_this.state.showFreeUserInfoModal
      });
    };

    _this.state = {
      showProUserInfoModal: false,
      showFreeUserInfoModal: false
    };
    return _this;
  }

  (0, _createClass3.default)(OrderLicenseForm, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _props = this.props,
          user = _props.user,
          company = _props.company,
          _props$fields = _props.fields,
          profile = _props$fields.profile,
          business_id = _props$fields.business_id,
          company_name = _props$fields.company_name,
          address = _props$fields.address,
          postal_area = _props$fields.postal_area,
          postal_code = _props$fields.postal_code;

      if (company) {
        profile.onChange("COMPANY");
        business_id.onChange(company.business_id);
        company_name.onChange(company.name);
        address.onChange(company.address.street_address);
        postal_area.onChange(company.address.postal_area);
        postal_code.onChange(company.address.postal_code);
      } else {
        profile.onChange("USER");
        address.onChange(user.address.street_address);
        postal_area.onChange(user.address.postal_area);
        postal_code.onChange(user.address.postal_code);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _state = this.state,
          showProUserInfoModal = _state.showProUserInfoModal,
          showFreeUserInfoModal = _state.showFreeUserInfoModal;
      var _props2 = this.props,
          license = _props2.license,
          handleSubmit = _props2.handleSubmit,
          profile = _props2.fields.profile;

      return _react2.default.createElement(
        "form",
        { id: "orderLicense", className: "col col-xs-12", onSubmit: handleSubmit(this.onSubmit) },
        _react2.default.createElement(
          "h2",
          { className: "h4 form-title" },
          "Tilaa maksullinen profiili"
        ),
        _react2.default.createElement(
          "p",
          null,
          " Sinulla ei ole maksullista profiilia tai profiilisi on vanhentunut "
        ),
        this.renderSelectProfiletype(),
        this.renderCompanyUserDesc(),
        this.renderTitle(),
        this.renderCompanyFields(),
        this.renderError(),
        this.renderSubmit(),
        _react2.default.createElement(_CompanyUserInfoModal2.default, {
          isShowingModal: showProUserInfoModal,
          handleClose: this.toggleProUserModal })
      );
    }
  }, {
    key: "renderError",
    value: function renderError() {
      var orderLicenseError = this.props.license.orderLicenseError;

      if (orderLicenseError) {
        return _react2.default.createElement(
          "p",
          { className: "error-message error-js" },
          "Tilauksen aikana tapahtui virhe. Yrit\xE4 my\xF6hemmin uudelleen tai ota yhteytt\xE4 Maap\xF6rssiin."
        );
      }
    }
  }, {
    key: "renderTitle",
    value: function renderTitle() {
      var profile = this.props.fields.profile;

      // if (profile.value === "USER") {
      //   return <h2 className="h4 form-title form-title-js"> Siirry maksamaan</h2>;
      // }

      if (profile.value === "COMPANY") {
        return _react2.default.createElement(
          "h2",
          { className: "h4 form-title form-title-js" },
          " Laskutustiedot"
        );
      }
    }
  }, {
    key: "renderSelectProfiletype",
    value: function renderSelectProfiletype() {
      var profile = this.props.fields.profile;


      return _react2.default.createElement(
        "div",
        { className: "row" },
        _react2.default.createElement(
          "div",
          { className: "col col-sm-6" },
          _react2.default.createElement(
            "div",
            { className: "row" },
            _react2.default.createElement(
              "div",
              { className: "col col-xs-10" },
              _react2.default.createElement(_RadioGroup2.default, {
                name: "profile",
                fieldProps: profile,
                options: [{ id: "profile-professional", value: "COMPANY", title: "Ammattilaisprofiili" }] })
            ),
            _react2.default.createElement(
              "div",
              { className: "col-xs-2" },
              _react2.default.createElement(
                "span",
                { className: "info-button", onClick: this.toggleProUserModal },
                "?"
              ),
              _react2.default.createElement(
                "span",
                { className: "info-button", onClick: this.toggleFreeUserModal },
                "?"
              )
            )
          )
        )
      );
    }
  }, {
    key: "renderUserFields",
    value: function renderUserFields() {
      var profile = this.props.fields.profile;


      if (profile.value !== "USER") {
        return null;
      }

      return _react2.default.createElement(
        "div",
        { className: "user-fields-js" },
        this.renderAddressFields(),
        "Palvelu ohjaa sinut Paytrail verkkomaksupalveluun"
      );
    }
  }, {
    key: "renderCompanyFields",
    value: function renderCompanyFields() {
      var _props$fields2 = this.props.fields,
          profile = _props$fields2.profile,
          business_id = _props$fields2.business_id,
          company_name = _props$fields2.company_name;


      if (profile.value !== "COMPANY") {
        return null;
      }

      return _react2.default.createElement(
        "div",
        { className: "company-fields-js" },
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-sm-4" },
            _react2.default.createElement(_Input2.default, { id: "business_id", type: "text", label: "Y-tunnus", fieldProps: business_id })
          ),
          _react2.default.createElement(
            "div",
            { className: "col col-sm-8" },
            _react2.default.createElement(_Input2.default, { id: "company_name", type: "text", label: "Yritys", fieldProps: company_name })
          )
        ),
        this.renderAddressFields()
      );
    }
  }, {
    key: "renderAddressFields",
    value: function renderAddressFields() {
      var _props$fields3 = this.props.fields,
          address = _props$fields3.address,
          postal_code = _props$fields3.postal_code,
          postal_area = _props$fields3.postal_area,
          order_reference = _props$fields3.order_reference,
          profile = _props$fields3.profile;


      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-xs-12" },
            _react2.default.createElement(_Input2.default, { id: "address", type: "text", label: "Katuosoite", fieldProps: address })
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-xs-6" },
            _react2.default.createElement(_Input2.default, { id: "postal_code", type: "text", label: "Postinumero", fieldProps: postal_code })
          ),
          _react2.default.createElement(
            "div",
            { className: "col col-xs-6" },
            _react2.default.createElement(_Input2.default, { id: "postal_area", type: "text", label: "Paikkakunta", fieldProps: postal_area })
          ),
          profile.value === "COMPANY" ? _react2.default.createElement(
            "div",
            { className: "col col-xs-6" },
            _react2.default.createElement(_Input2.default, { id: "order_reference", type: "text", label: "Tilausviite", fieldProps: order_reference })
          ) : ""
        )
      );
    }

    // renderPrivateUserDesc() {
    //   const { profile } = this.props.fields;
    //   if (profile.value !== "USER") {
    //     return null;
    //   }
    //   return (
    //     <div>
    //       <h5> Yksityisprofiili: </h5>
    //       <ul className='mp-list'>
    //         <li>
    //           <i className="icon-mp-ok"></i>Ilmoitusten tarkkojen tietojen lukeminen
    //         </li>
    //         <li>
    //           <i className="icon-mp-ok"></i>Ilmoitukset näkyvät kartalla oikeissa paikoissa
    //         </li>
    //         <li>
    //           <i className="icon-mp-ok"></i>Omien ilmoitusten muokkaaminen
    //         </li>
    //         <li>
    //           <i className="icon-mp-ok"></i>Ostetut vastaanottolipukkeet talteen omaan profiiliin
    //         </li>
    //       </ul>
    //     </div>
    //   );
    // }

  }, {
    key: "renderCompanyUserDesc",
    value: function renderCompanyUserDesc() {
      var profile = this.props.fields.profile;

      if (profile.value !== "COMPANY") {
        return null;
      }
      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
          "h5",
          null,
          "Ammattilaisprofiili "
        ),
        _react2.default.createElement(
          "ul",
          { className: "mp-list" },
          _react2.default.createElement(
            "li",
            null,
            _react2.default.createElement("i", { className: "icon-mp-ok" }),
            "Ilmoitusten tarkkojen tietojen lukeminen"
          ),
          _react2.default.createElement(
            "li",
            null,
            _react2.default.createElement("i", { className: "icon-mp-ok" }),
            "Ilmoitukset n\xE4kyv\xE4t kartalla oikeissa paikoissa"
          ),
          _react2.default.createElement(
            "li",
            null,
            _react2.default.createElement("i", { className: "icon-mp-ok" }),
            "Omien ilmoitusten muokkaaminen"
          ),
          _react2.default.createElement(
            "li",
            null,
            _react2.default.createElement("i", { className: "icon-mp-ok" }),
            "Ostetut vastaanottolipukkeet talteen omaan profiiliin"
          )
        )
      );
    }
  }, {
    key: "renderSubmit",
    value: function renderSubmit() {
      var _props3 = this.props,
          license = _props3.license,
          profile = _props3.fields.profile;

      if (profile.value === "COMPANY") {
        return _react2.default.createElement(_SubmitButton2.default, { text: "Vahvistamaan", submitting: license.orderLicenseLoading || false });
      }

      // if (profile.value === "USER") {
      //   return (
      //     <SubmitButton text="Siirry maksamaan" submitting={license.orderLicenseLoading || false} />
      //   )
      // }
    }
  }]);
  return OrderLicenseForm;
}(_react.Component), _class.propTypes = {
  user: _react.PropTypes.object.isRequired,
  fields: _react.PropTypes.object.isRequired,
  license: _react.PropTypes.object.isRequired,
  company: _react.PropTypes.object,
  confirmPage: _react.PropTypes.func.isRequired,
  handleSubmit: _react.PropTypes.func.isRequired
}, _temp);
exports.default = OrderLicenseForm;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/license/OrderLicenseForm.js
 ** module id = 1153
 ** module chunks = 0
 **/